import { Component } from '@angular/core';
import { InvoiceListPharmacistComponent } from '../../../../components/user-dashboard-component/invoice-list-pharmacist/invoice-list-pharmacist-component';

@Component({
  selector: 'app-invoice-list-pharmacist',
  imports: [InvoiceListPharmacistComponent],
  templateUrl: './invoice-list-pharmacist.html',
  styleUrl: './invoice-list-pharmacist.scss',
})
export class InvoiceListPharmacist {

}
